const virtualPath = ''; //process.env.REACT_APP_VIRTUAL_PATH || "/";
const autoCompleteDelay = 300; // Set your desired delay time in milliseconds
export { virtualPath, autoCompleteDelay };